const organization = {
    require_membership: 'Der Benutzer muss Mitglied der Organisation sein, um fortzufahren.',
};
export default Object.freeze(organization);
